﻿import { LoginForm, LoginRequest } from "@/ServerTypes/Membership";
import { Texts } from "@/ServerTypes/Texts";
import { PropertyPanel } from "@serenity-is/corelib";
import { ErrorHandling, isEmptyOrNull, notifyError, parseQueryString, resolveUrl, serviceCall, ServiceResponse, localText, htmlEncode } from "@serenity-is/corelib/q";

$(function () {
    var loginPanel = new LoginPanel($('#LoginPanel')).init();
    loginPanel.element.find('.forgot-password').appendTo('.field.Password');

    if ((document.getElementById('IsPublicDemo') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val('admin').attr('placeholder', 'admin')
        loginPanel["byId"]('Password').val('serenity').attr('placeholder', 'serenity');
    }
});

class LoginPanel extends PropertyPanel<LoginRequest, any> {

    protected getFormKey() { return LoginForm.formKey; }

    constructor(container: JQuery) {
        super(container);

        this.byId('LoginButton').click(e => {
            e.preventDefault();

            if (!this.validateForm())
                return;

            var request = this.getSaveEntity();

            serviceCall({
                url: resolveUrl('~/Account/Login'),
                request: request,
                onSuccess: () => {
                    this.redirectToReturnUrl();
                },
                onError: (response: ServiceResponse) => {
                    if (response != null && response.Error != null && response.Error.Code == "RedirectUserTo") {
                        window.location.href = response.Error.Arguments;
                        return;
                    }

                    if (response != null && response.Error != null && !isEmptyOrNull(response.Error.Message)) {
                        notifyError(response.Error.Message);
                        $('#Password').focus();

                        return;
                    }

                    ErrorHandling.showServiceError(response.Error);
                }
            });
        });
    }

    /**
     * Where a successful login lands. This runs on the primary auth flow and returnUrl is just a
     * query parameter, so it gets the same same-site check as the public link below - previously
     * it navigated to whatever was passed, including a fully absolute "https://evil.com".
     * An unsafe value falls back to the site root rather than being followed.
     */
    protected redirectToReturnUrl() {
        var returnUrl = LoginPanel.readReturnUrl();
        if (LoginPanel.isSafeReturnPath(returnUrl)) {
            var hash = window.location.hash;
            if (hash != null && hash != '#')
                returnUrl += hash;
            window.location.href = returnUrl;
        }
        else {
            window.location.href = resolveUrl('~/');
        }
    }

    /**
     * Is this returnUrl safe to navigate to? returnUrl is attacker-controllable (it is just a
     * query parameter on the login link), so only same-site relative paths are accepted.
     *
     * Anchoring on `^\/(?!\/)` alone is NOT enough, because the browser rewrites the string
     * before resolving it (WHATWG URL spec):
     *   - "\" is treated as "/", so "/\evil.com" resolves exactly like "//evil.com"
     *   - ASCII tab, CR and LF are STRIPPED entirely, so "/\n/evil.com" also collapses to
     *     "//evil.com" while the regex happily sees a leading "/" followed by "\n"
     * Both were verified against a WHATWG-conformant resolver, not reasoned about.
     *
     * So the character set is checked as well: reject a backslash, DEL, and anything at or
     * below U+0020 (covers tab/CR/LF/NUL/space and every other control character). None of
     * those has a legitimate place in these return paths - a real one is percent-encoded.
     * Note parseQueryString percent-DECODES, so this runs on the decoded value, which is the
     * form the browser will actually resolve.
     */
    /**
     * parseQueryString uses a bare decodeURIComponent, which throws URIError on a malformed escape
     * anywhere in the query string - "?%" is enough. An unhandled throw here would surface in
     * redirectToReturnUrl immediately after a successful sign-in, stranding a user who had in
     * fact just authenticated. Treat an unparseable query as having no returnUrl.
     */
    private static readReturnUrl(): string {
        try {
            var q = parseQueryString();
            return q['returnUrl'] || q['ReturnUrl'];
        }
        catch (e) {
            return null;
        }
    }

    private static isSafeReturnPath(returnUrl: string) {
        if (!returnUrl)
            return false;

        // Explicit code-point scan rather than a regex character class: the bytes being
        // rejected are invisible in source, and a mistyped range here is a silent hole.
        for (var i = 0; i < returnUrl.length; i++) {
            var c = returnUrl.charCodeAt(i);
            var isControlOrSpace = c <= 0x20;
            var isBackslash = c === 0x5c;
            var isDelete = c === 0x7f;
            if (isControlOrSpace || isBackslash || isDelete)
                return false;
        }

        return /^\/(?!\/)/.test(returnUrl);
    }

    /**
     * Where "Continue without logging in" goes: always the public warranty landing page.
     *
     * Honouring returnUrl here reads as the helpful thing to do, but it breaks in the case that
     * matters. returnUrl is only populated when the visitor was BOUNCED to this page, and the
     * page that bounced them is by definition one that requires a login - so following it sends
     * them straight back to sign-in and the link appears to do nothing. It only behaved
     * correctly for a visitor arriving from a public form, who had somewhere to go anyway.
     *
     * The landing page is the one route guaranteed to render for an anonymous visitor, so it is
     * the only safe target. Note the site root is NOT an alternative - it requires a login too.
     */
    protected getContinueWithoutLoginUrl() {
        return resolveUrl('~/Warranty/RequestionInstruction');
    }

    protected getTemplate() {
        return `
<div class="login-card-wrap">
    <div class="s-Panel p-4 login-card">
        <div class="text-center login-brand">
            <img src="${resolveUrl("~/Content/site/images/curbtenderlogo.png")}" width="140" height="32" alt="Curbtender" />
            <p class="login-subtitle">Dealer &amp; Customer Portal</p>
        </div>
        <form id="~_Form" action="">
            <div id="~_PropertyGrid"></div>
            <div class="px-field">
                <button id="~_LoginButton" type="submit" class="btn btn-primary mt-3 w-100">
                    ${htmlEncode(Texts.Forms.Membership.Login.SignInButton)}
                </button>
            </div>
            <div class="px-field d-flex justify-content-between login-links">
                <a class="text-decoration-none" href="${resolveUrl('~/Account/ForgotPassword')}">
                    ${htmlEncode(Texts.Forms.Membership.Login.ForgotPassword)}
                </a>
                <a class="text-decoration-none" href="${resolveUrl('~/Account/SignUp')}">Create an account</a>
            </div>
        </form>
    </div>
    <p class="text-center login-continue">
        Don't want an account?
        <a class="text-decoration-none" href="${htmlEncode(this.getContinueWithoutLoginUrl())}">Continue without logging in</a>
    </p>
</div>
`;
    }
}